import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.15 21.55a1.23 1.23 0 0 1-.9-.38L.84 13.56a2.25 2.25 0 0 1 0-3.12l7.41-7.62A1.25 1.25 0 1 1 10 4.57l-6.85 7.08a.5.5 0 0 0 0 .7L10 19.43a1.24 1.24 0 0 1-.89 2.12Zm5.7 0a1.24 1.24 0 0 1-.85-2.12l6.89-7.08a.5.5 0 0 0 0-.7L14 4.57a1.25 1.25 0 1 1 1.79-1.75l7.41 7.62a2.25 2.25 0 0 1 0 3.12l-7.41 7.61a1.23 1.23 0 0 1-.94.38m6.52-9.37"
    }, null, -1)
  ]));
}
const EditorCode = { render };
export {
  EditorCode as default,
  render
};
//# sourceMappingURL=EditorCode.svg.js.map
